import styled from 'styled-components';
import { OnPrimary } from '../../Colors';

const defaultStyle =  {
	Wrapper : styled.div`
        display : flex;
        align-items : center;
        justify-content : flex-end;
        padding : 1rem 2rem;
        color : ${OnPrimary};
        height : 10vh;
    `,
	Link : styled.a`
        color : ${OnPrimary};
        cursor : pointer;
        &:hover{
            color : ${OnPrimary};
        }
        &:focus{
            color : ${OnPrimary};
        }
    `,
	Divider : styled.div`
        margin : 0 1rem;
    `
};

const mobileStyle = {};

export default defaultStyle;
export {mobileStyle};